import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {UserComplianceDetailsResponseModel, UserComplianceListItemModel} from '../companyMonitorTypes'

interface UserComplianceState {
  loading: boolean
  list: UserComplianceListItemModel[]
  details: UserComplianceDetailsResponseModel | null
  error: string | null
}

const initialState: UserComplianceState = {
  loading: false,
  list: [],
  details: null,
  error: null,
}

export const userComplianceSlice = createSlice({
  name: 'userComplianceSlice',
  initialState,
  reducers: {
    loading: (state) => {
      state.loading = true
      state.error = null
    },
    userCompliancesFetched: (state, action: PayloadAction<UserComplianceListItemModel[]>) => {
      state.loading = false
      state.list = action.payload
      state.error = null
    },
    userCompliancesFetchFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    userComplianceDetailsFetched: (state, action: PayloadAction<UserComplianceDetailsResponseModel>) => {
      state.loading = false
      state.details = action.payload
      state.error = null
    },
    userComplianceDetailsFetchFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    userComplianceDecisionSuccess: (state, action: PayloadAction<UserComplianceDetailsResponseModel>) => {
      state.loading = false
      state.details = action.payload
      state.error = null
    },
    userComplianceDecisionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    }
  }
})

export const {
  loading,
  userCompliancesFetched,
  userCompliancesFetchFailure,
  userComplianceDetailsFetched,
  userComplianceDetailsFetchFailure,
  userComplianceDecisionSuccess,
  userComplianceDecisionFailure,
} = userComplianceSlice.actions

export default userComplianceSlice.reducer
